import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { comOrder } from '../actions/orderActions';
import QRCode from 'qrcode';
import { useNavigate } from 'react-router';
import useAxios from '../axios/useAxios';
import Rating from '../components/card/RatingCard';
import AccountCard from '../components/card/AccountCard2';
import InvoiceCard from '../components/card/InvoiceCard';
import { ACCOUNT, HOME } from '../constants/routes';
import RatingPopup from '../components/RatingPopup';
import { formatPriceWithEuro } from '../utils/StringUtils';
import { calculateTotalToPay } from '../utils/order/orderUtils';

const OrderSuccess = () => {
  const toPrice = (num) => parseFloat(num).toFixed(2);
  window.scrollTo(0, 0);

  // const axiosInstance = config()
  const axiosInstance = useAxios();
  const [QrCode, setQrCode] = useState('');
  const { store } = useSelector((state) => state.store);
  const { orderId } = useParams();

  const { cartItems } = useSelector((state) => state.cart);
  const user = useSelector((state) => state.user);
  const [com, setCom] = useState('');
  const [iscom, setIscom] = useState(false);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setLoader(false);

    if (cartItems && cartItems.verification === false) {
      navigate('/scancheck');
    }
  }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(detailsOrder(orderId, axiosInstance));
    try {
      QRCode.toDataURL(`https://www.test.pikkopay.fr/check/${orderId}`, {
        /*color: {dark: "#755FE2", light:"#00FFFFFF"},*/ margin: 0,
      }).then(setQrCode);
    } catch (err) {
      console.log(err);
    }
  }, [orderId, dispatch]);

  const getData = (val) => {
    setCom(val.target.value);
    console.log(com);
  };

  const comSubmit = () => {
    dispatch(comOrder(cartItems._id, com, axiosInstance));
    setIscom(true);
  };

  const popup = () => {
    let element = document.getElementById('orderPopup');
    if (element.style.visibility === 'hidden') {
      element.style.visibility = 'visible';
    } else {
      element.style.visibility = 'hidden';
    }
  };
  const [popupinscr, setPopupinscr] = useState(false);
  const handleclosepopinscr = () => {
    setPopupinscr(false);
  };
  const handleopenpopinscr = () => {
    localStorage.setItem('animSuccess', true);
  };

  // const [instance, updateInstance] = usePDF({ document: MyDocument });
  return (
    <>
      {cartItems ? (
        <>
          <RatingPopup />

          <div id="invoice" className="flex flex-col gap-10 p-8 bg-white">
            {/* {Invoice(orderDetails, store)} */}

            <div className="flex flex-col justify-center gap-14 mt-10">
              <div className=" flex justify-center flex-col items-center ">
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/pikkopay.appspot.com/o/Webapp%2ForderSuccess%2ForderSuccess_success.png?alt=media&token=310d59d8-83e8-4cca-805e-890a4afaa3b4"
                  alt="logo_success"
                  className="success w-20 h-auto"
                />

                <h2
                  className="text-center text-4xl mt-8 mb-4"
                  style={{ fontFamily: 'intersemibold' }}
                >
                  Facture
                </h2>

                <h2
                  className="text-5xl mb-4"
                  style={{ fontFamily: 'interbold' }}
                >
                  {formatPriceWithEuro(calculateTotalToPay(cartItems.itemsPrice, cartItems.promoPrice, cartItems?.jackpot?.amount))}
                </h2>

                <div className="flex flex-col gap-10 w-full">
                  <InvoiceCard
                    cartItems={cartItems}
                    store={store}
                    user={user}
                  />

                  <AccountCard user={user} cartItems={cartItems} />

                  <Rating
                    data={{
                      orderId: cartItems._id,
                      axiosInstance: axiosInstance,
                      store: store,
                    }}
                  />
                  {/* <InstallPWA/> */}
                </div>
              </div>
            </div>

            <button
              className="recus w-full geomanistBold h-full payer p-6 text-[1.7rem]  flex gap-4"
              onClick={() => navigate(user && user._id ? ACCOUNT : HOME)}
              style={{ backgroundColor: '#FFFfF1' }}
            >
              Retour à l'accueil
            </button>
          </div>
        </>
      ) : (
        <div
          className="absolute top-0 h-screen w-screen "
          style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
        >
          <div className="absolute  left-2/4 top-[25%]  -translate-x-2/4 ">
            <div className="lds-spinner white">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default OrderSuccess;
